import format from 'date-fns/format';

export default (date) => {
  return format(date, 'YYYY-MM-DD');
};



// WEBPACK FOOTER //
// ./src/utils/defaultFormatDate.js